import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  ListTodo,
  Bandage,
  BrickWall,
  CassetteTape,
  ShoppingBasket,
  BadgeIndianRupee,
  CalendarClock,
  BaggageClaim,
  Captions,
  Contact,
  BotMessageSquare,
  MessageCircleHeart,
  CupSoda} from 'lucide-react';

const AppElementsMenuCard =({activeCard,icon,title ,onClickPopup})=>{

    

 const Icon=   icon===0?<CupSoda size={23}  color="#90CAF9" />:icon===1?<CupSoda size={23}  color="#90CAF9" 
        />:icon===2?<Bandage size={23}  color="#90CAF9"  
        />:icon===3?<BrickWall size={23}   color="#90CAF9"  
        />:icon===4?<CassetteTape size={23} color="#90CAF9" 
        />:icon===5?
       <ShoppingBasket size={23}   color="#90CAF9" />
       :icon===6?<BadgeIndianRupee size={23}  color="#90CAF9" />
       :icon===7?<CalendarClock size={23}  color="#90CAF9" />:
       icon===8?<BaggageClaim size={23}  color="#90CAF9" />:
       icon===9?<Captions size={23}  color="#90CAF9" />:
       icon===10?<Contact size={23}  color="#90CAF9" />:
       icon===11?<BotMessageSquare size={23}  color="#90CAF9" />:
        icon===12?<MessageCircleHeart size={23}  color="#90CAF9" />:"";
     
 const iconWhite=   icon===0?<ListTodo size={23}  color="#fff" />:icon===1?<CupSoda size={23}  color="#fff" 
 />:icon===2?<Bandage size={23}  color="#fff"  
 />:icon===3?<BrickWall size={23}   color="#fff"  
 />:icon===4?<CassetteTape size={23} color="#fff" 
 />:icon===5?
<ShoppingBasket size={23}   color="#fff" />
:icon===6?<BadgeIndianRupee size={23}  color="#fff" />
:icon===7?<CalendarClock size={23}  color="#fff" />
:icon===8?<BaggageClaim size={23}  color="#fff" />
:icon===9?<Captions size={23}  color="#fff" />
:icon===10?<Contact size={23}  color="#fff" />
:icon===11?<BotMessageSquare size={23}  color="#fff" />
:icon===12?<MessageCircleHeart size={23}  color="#fff" />:"";

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const cardBg =activeCard?"rgba(255,114,94,0.1)":" #fff";
      const styleCard={marginBottom:"20px",height:"48px",cursor:"pointer",background:cardBg,border:"0px solid #fff",padding:"5px"}
      const cardBgIcon =activeCard?"rgba(255,114,94,0.7)":" #f9f9f9";
      const styleCardIconIcon={background:cardBgIcon,width:"30px",height:"30px",borderRadius:"15%",
        alignContent:"center",textAlign:"center",padding:"5px",}
      return (<><div   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()} align="left" className="itemCourseOuter"
       style={styleCard}> 
      <div  className="appItemCardInnergrid" ><div style={styleCardIconIcon}>{activeCard?iconWhite:Icon}</div> 
      
         <div  className="itemAppSettingsTopCard " style={{fontSize:"14px",padding:"2px",paddingTop:"10px",textAlign:"left",fontWeight:"bold"}}>{title}</div>
         <div style={{
              alignContent:"center",textAlign:"center",padding:"5px"}}><ChevronRight size={18}  color={"#222"} /></div>
        </div>
       
      <div className="set-expiry-card-bottom">
      <div></div>
         
         </div>   </div>
        </>)
}
export default AppElementsMenuCard;

